import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { getStatus } from "../../../helpers/shipmentStatusHelpers";

export default class SortedListStatus extends PureComponent {
  static propTypes = {
    loadStatus: PropTypes.object
  };

  static defaultProps = {
    loadStatus: {}
  };

  render() {
    const loadStatus = getStatus(this.props.loadStatus);

    return <span className={classNames("list-status__label", loadStatus.className)}>{loadStatus.label}</span>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/SortedList/SortedListStatus.js